import TrackingService from "@services/tracking/tracking.service";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { TypedAnalyticsEvent } from "../types/analyticsEvent";
import { ListImpressionTrackingInfo } from "../types/trackingInfo/listImpressionTrackingInfo";
import { getPageInfo, getUserInfo } from "./pageImpressionTracker";

const trackListImpression = (name: string, ids: Array<string>, meta?: any) => {
    const event: TypedAnalyticsEvent<ListImpressionTrackingInfo> = {
        event: EventTypes.ListImpression,
        payload: {
            eventData: {
                name,
                ids,
                meta,
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackListImpression };
